var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ inverse: _vm.inverse },attrs:{"id":"custom-button"}},[(_vm.previous_icon)?_c('font-awesome-icon',{staticClass:"custom-buttom-icon",attrs:{"icon":_vm.previous_icon}}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }